import React, { useState, useEffect, useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { Collapse } from "react-bootstrap";
import { Trans } from "react-i18next";
import { AuthContext } from "../Context/AuthContext";

const Sidebar = () => {
  const [menuState, setMenuState] = useState({});
  const location = useLocation();
  const { permissions, name, designation } = useContext(AuthContext);

  const toggleMenuState = (menu) => {
    setMenuState((prevState) => {
      if (prevState[menu]) {
        return {};
      }
      return { [menu]: true };
    });
  };


  const isPathActive = (path) => location.pathname.startsWith(path);

  useEffect(() => {
    const onRouteChanged = () => {
      document.querySelector("#sidebar")?.classList.remove("active");
      setMenuState({}); // Reset the menu state on route change

      const dropdownPaths = [
        { path: "/dashboard", state: "dashboardMenuOpen" },
        // { path: "/jfmc", state: "dashboardMenuOpen" },
        // { path: "/review-dashboard", state: "dashboardMenuOpen" },
        { path: "/basic-ui", state: "basicUiMenuOpen" },
        { path: "/form-elements", state: "formElementsMenuOpen" },
        { path: "/tables", state: "tablesMenuOpen" },
        { path: "/charts", state: "chartsMenuOpen" },
        { path: "/icons", state: "iconsMenuOpen" },
        { path: "/range", state: "rangeMenuOpen" },
        { path: "/intrest", state: "intrestMenuOpen" },
        { path: "/type/loan", state: "loanTypeMenuOpen" },
        { path: "/vfc", state: "vfcMenuOpen" },
        { path: "/jfmc/types", state: "vfcMenuOpen" },
        { path: "/member", state: "memberMenuOpen" },
        { path: "/SHG", state: "shgMenuOpen" },
        { path: "/loan", state: "loanMenuOpen" },
        { path: "/vouchers", state: "vouchersMenuOpen" },
        { path: "/transaction", state: "transactionsMenuOpen" },
        { path: "/user", state: "userMenuOpen" },
        { path: "/document", state: "documentMenuOpen" },
        { path: "/eco", state: "ecoMenuOpen" },
        { path: "/et-visitors", state: "ecoMenuOpen" },
        { path: "/jfmc-fee", state: "jfmcMaintenanceFeeMenuOpen" },
        { path: "/verify-manual-payments", state: "jfmcMaintenanceFeeMenuOpen" },
        { path: "/jfmc-fee/bank-upload", state: "jfmcMaintenanceFeeMenuOpen" }
      ];

      dropdownPaths.forEach((obj) => {
        if (isPathActive(obj.path)) {
          setMenuState((prevState) => ({
            ...prevState,
            [obj.state]: true,
          }));
        }
      });
    };

    onRouteChanged();
  }, [location]);

  return (
    <nav className="sidebar sidebar-offcanvas" id="sidebar">
      <ul className="nav">
        <li className="nav-item nav-profile">
          <a
            href="!#"
            className="nav-link"
            onClick={(evt) => evt.preventDefault()}
          >
            <div className="nav-profile-image">
              <img
                src={require("../../assets/images/faces/default-face.png")}
                alt="profile"
              />
              <span className="login-status online"></span>
            </div>
            <div className="nav-profile-text">
              <span className="font-weight-bold mb-2">
                <Trans>{name}</Trans>
              </span>
              <span className="text-secondary text-small">
                <Trans>{designation}</Trans>
              </span>
            </div>
            <i className="mdi mdi-bookmark-check text-success nav-profile-badge"></i>
          </a>
        </li>

        <li
          className={
            isPathActive("/dashboard") ? "nav-item active" : "nav-item"
          }
        >
          <div
            className={
              menuState.dashboardMenuOpen
                ? "nav-link menu-expanded"
                : "nav-link"
            }
            onClick={() => toggleMenuState("dashboardMenuOpen")}
            data-toggle="collapse"
          >
            <span className="menu-title">
              <Trans>Dashboard</Trans>
            </span>
            <i className="menu-arrow"></i>
            <i className="mdi mdi-home menu-icon"></i>
          </div>

          <Collapse in={menuState.dashboardMenuOpen}>
            <ul className="nav flex-column sub-menu">
              <li className="nav-item">
                <Link
                  className={isPathActive("/dashboard") ? "nav-link active" : "nav-link"}
                  to="dashboard"
                >
                  <Trans>Dashboard</Trans>
                </Link>
              </li>

              <li className="nav-item">
                <Link
                  className={
                    isPathActive("/dashboard/monthly-review") ? "nav-link active" : "nav-link"
                  }
                  to="dashboard/monthly-review"
                >
                  <Trans>Progress Report</Trans>
                </Link>
              </li>
            </ul>
          </Collapse>
        </li>

        {/* State Menu */}
        {permissions.includes("ManageState") && (
          <li
            className={isPathActive("/state") ? "nav-item active" : "nav-item"}
          >
            <Link className="nav-link" to="state">
              <span className="menu-title">
                <Trans>State</Trans>
              </span>
              <i className="mdi mdi-map menu-icon"></i>
            </Link>
          </li>
        )}

        {/* Circle Menu */}
        {permissions.includes("ManageCircle") && (
          <li
            className={isPathActive("/circle") ? "nav-item active" : "nav-item"}
          >
            <Link className="nav-link" to="circle">
              <span className="menu-title">
                <Trans>Circle</Trans>
              </span>
              <i className="mdi mdi-circle-outline menu-icon"></i>
            </Link>
          </li>
        )}
        {/* Division Menu */}
        {permissions.includes("ManageDivision") && (
          <li
            className={
              isPathActive("/division") ? "nav-item active" : "nav-item"
            }
          >
            <Link className="nav-link" to="division">
              <span className="menu-title">
                <Trans>Division</Trans>
              </span>
              <i className="mdi mdi-layers menu-icon"></i>
            </Link>
          </li>
        )}

        <li className={isPathActive("/range") ? "nav-item active" : "nav-item"}>
          {permissions.includes("ManageRange") && (
            <div
              className={
                menuState.rangeMenuOpen ? "nav-link menu-expanded" : "nav-link"
              }
              onClick={() => toggleMenuState("rangeMenuOpen")}
              data-toggle="collapse"
            >
              <span className="menu-title">
                <Trans>Range</Trans>
              </span>
              <i className="menu-arrow"></i>
              <i className="mdi mdi-ruler menu-icon"></i>
            </div>
          )}
          <Collapse in={menuState.rangeMenuOpen}>
            <ul className="nav flex-column sub-menu">
              {permissions.includes("ManageRange") && (
                <li className="nav-item">
                  <Link
                    className={
                      isPathActive("/range") ? "nav-link active" : "nav-link"
                    }
                    to="range"
                  >
                    <Trans>Ranges</Trans>
                  </Link>
                </li>
              )}
              {permissions.includes("ManageBeats") && (
                <li className="nav-item">
                  <Link
                    className={
                      isPathActive("/range/beat")
                        ? "nav-link active"
                        : "nav-link"
                    }
                    to="range/beat"
                  >
                    <Trans>Beat</Trans>
                  </Link>
                </li>
              )}
            </ul>
          </Collapse>
        </li>

        {/* VFC Menu */}

        <li className={isPathActive("/vfc") || isPathActive("/jfmc/types") ? "nav-item active" : "nav-item"}>
          {permissions.includes("VFCMenu") && (
            <div
              className={
                menuState.vfcMenuOpen ? "nav-link menu-expanded" : "nav-link"
              }
              onClick={() => toggleMenuState("vfcMenuOpen")}
              data-toggle="collapse"
            >
              <span className="menu-title">
                <Trans>JFMC</Trans>
              </span>
              <i className="menu-arrow"></i>
              <i className="mdi mdi-menu menu-icon"></i>
            </div>
          )}
          <Collapse in={menuState.vfcMenuOpen}>
            <ul className="nav flex-column sub-menu">
              {permissions.includes("VfcDashboard") && (
                <li className="nav-item">
                  <Link
                    className={
                      isPathActive("/vfc/dashboard")
                        ? "nav-link active"
                        : "nav-link"
                    }
                    to="vfc/dashboard"
                  >
                    <Trans>JFMC Dashboard</Trans>
                  </Link>
                </li>
              )}

              {permissions.includes("VfcDashboard") && (
                <li className="nav-item">
                  <Link
                    className={
                      isPathActive("/vfc/Status")
                        ? "nav-link active"
                        : "nav-link"
                    }
                    to="vfc/Status"
                  >
                    <Trans>JFMC Status</Trans>
                  </Link>
                </li>
              )}
              {permissions.includes("VfcDashboard") && (
                <li className="nav-item">
                  <Link
                    className={
                      isPathActive("/vfc/Renewal")
                        ? "nav-link active"
                        : "nav-link"
                    }
                    to="vfc/Renewal"
                  >
                    <Trans>JFMC Renewal Form</Trans>
                  </Link>
                </li>
              )}
              {permissions.includes("VFCBasicReport") && (
                <li className="nav-item">
                  <Link
                    className={
                      isPathActive("/vfc/basic/report")
                        ? "nav-link active"
                        : "nav-link"
                    }
                    to="vfc/basic/report"
                  >
                    <Trans>JFMC Daily Report</Trans>
                  </Link>
                </li>
              )}
              {permissions.includes("AddVfc") && (
                <li className="nav-item">
                  <Link
                    className={
                      isPathActive("/vfc/add") ? "nav-link active" : "nav-link"
                    }
                    to="vfc/add"
                  >
                    <Trans>Add JFMC</Trans>
                  </Link>
                </li>
              )}
              {permissions.includes("ManageVfc") && (
                <li className="nav-item">
                  <Link
                    className={
                      isPathActive("/vfc/manage")
                        ? "nav-link active"
                        : "nav-link"
                    }
                    to="vfc/manage"
                  >
                    <Trans>Manage JFMC</Trans>
                  </Link>
                </li>
              )}

              {permissions.includes("VfcProfile") && (
                <li className="nav-item">
                  <Link
                    className={
                      isPathActive("/vfc/profile")
                        ? "nav-link active"
                        : "nav-link"
                    }
                    to="vfc/profile"
                  >
                    <Trans>JFMC Profile</Trans>
                  </Link>
                </li>
              )}
              {permissions.includes("VfcCollab") && (
                <li className="nav-item">
                  <Link
                    className={
                      isPathActive("/jfmc/types") ? "nav-link active" : "nav-link"
                    }
                    to="jfmc/types"
                  >
                    <Trans>JFMC Types</Trans>
                  </Link>
                </li>
              )}
              {permissions.includes("UpdateVFC&Audit") && (
                <li className="nav-item">
                  <Link
                    className={
                      isPathActive("/vfc/update/renewal")
                        ? "nav-link active"
                        : "nav-link"
                    }
                    to="vfc/update/renewal"
                  >
                    <Trans>Update JFMC & Audit </Trans>
                  </Link>
                </li>
              )}
            </ul>
          </Collapse>
        </li>
        {/* Eco Tourism Menu */}

        <li className={isPathActive("/eco") || isPathActive("/et-visitors") ? "nav-item active" : "nav-item"}>
          {permissions.includes("VFCMenu") && (
            <div
              className={
                menuState.ecoMenuOpen ? "nav-link menu-expanded" : "nav-link"
              }
              onClick={() => toggleMenuState("ecoMenuOpen")}
              data-toggle="collapse"
            >
              <span className="menu-title">
                <Trans>Eco Tourism</Trans>
              </span>

              <i className="menu-arrow"></i>

              <i className="mdi mdi-nature menu-icon"></i>
            </div>
          )}

          <Collapse in={menuState.ecoMenuOpen}>
            <ul className="nav flex-column sub-menu">
              {permissions.includes("VfcDashboard") && (
                <li className="nav-item">
                  <Link
                    className={
                      isPathActive("/eco-dashboard")
                        ? "nav-link active"
                        : "nav-link"
                    }
                    to="eco-dashboard"
                  >
                    <Trans>Eco Dashboard</Trans>
                  </Link>
                </li>
              )}

              {permissions.includes("VfcDashboard") && (
                <li className="nav-item">
                  <Link
                    className={
                      isPathActive("/eco-tourism/new")
                        ? "nav-link active"
                        : "nav-link"
                    }
                    to="eco-tourism/new"
                  >
                    <Trans>Create Eco Tourism</Trans>
                  </Link>
                </li>
              )}

              {permissions.includes("VfcDashboard") && (
                <li className="nav-item">
                  <Link
                    className={
                      isPathActive("/eco-tourism/manage")
                        ? "nav-link active"
                        : "nav-link"
                    }
                    to="eco-tourism/manage"
                  >
                    <Trans>Manage Eco Tourism</Trans>
                  </Link>
                </li>
              )}

              {permissions.includes("VfcDashboard") && (
                <li className="nav-item">
                  <Link
                    className={
                      isPathActive("/et-visitors/entry")
                        ? "nav-link active"
                        : "nav-link"
                    }
                    to="et-visitors/entry"
                  >
                    <Trans>ET Visitors Entry</Trans>
                  </Link>
                </li>
              )}

              {permissions.includes("VfcDashboard") && (
                <li className="nav-item">
                  <Link
                    className={
                      isPathActive("/et-visitors/view")
                        ? "nav-link active"
                        : "nav-link"
                    }
                    to="et-visitors/view"
                  >
                    <Trans>View ET Visitors</Trans>
                  </Link>
                </li>
              )}
              {permissions.includes("VfcDashboard") && (
                <li className="nav-item">
                  <Link
                    className={
                      isPathActive("/eco-tourism-fees/new")
                        ? "nav-link active"
                        : "nav-link"
                    }
                    to="eco-tourism-fees/new"
                  >
                    <Trans>Create Eco Tourism Fees</Trans>
                  </Link>
                </li>
              )}
              {permissions.includes("VfcDashboard") && (
                <li className="nav-item">
                  <Link
                    className={
                      isPathActive("/eco-tourism-fees/manage")
                        ? "nav-link active"
                        : "nav-link"
                    }
                    to="eco-tourism-fees/manage"
                  >
                    <Trans>Manage Eco Tourism Fees</Trans>
                  </Link>
                </li>
              )}

            </ul>
          </Collapse>
        </li>
        {/* Member Menu */}
        <li
          className={isPathActive("/member") ? "nav-item active" : "nav-item"}
        >
          {permissions.includes("MemberMenu") && (
            <div
              className={
                menuState.memberMenuOpen ? "nav-link menu-expanded" : "nav-link"
              }
              onClick={() => toggleMenuState("memberMenuOpen")}
              data-toggle="collapse"
            >
              <span className="menu-title">
                <Trans>Member</Trans>
              </span>
              <i className="menu-arrow"></i>
              <i className="mdi mdi-nature-people menu-icon"></i>
            </div>
          )}
          <Collapse in={menuState.memberMenuOpen}>
            <ul className="nav flex-column sub-menu">
              {permissions.includes("AddMember") && (
                <li className="nav-item">
                  <Link
                    className={
                      isPathActive("/member/add")
                        ? "nav-link active"
                        : "nav-link"
                    }
                    to="member/add"
                  >
                    <Trans>Add Member</Trans>
                  </Link>
                </li>
              )}
              {permissions.includes("ManageMember") && (
                <li className="nav-item">
                  <Link
                    className={
                      isPathActive("/member/manage")
                        ? "nav-link active"
                        : "nav-link"
                    }
                    to="member/manage"
                  >
                    <Trans>Manage Member</Trans>
                  </Link>
                </li>
              )}
              {permissions.includes("MemberProfile") && (
                <li className="nav-item">
                  <Link
                    className={
                      isPathActive("/member/profile")
                        ? "nav-link active"
                        : "nav-link"
                    }
                    to="member/profile"
                  >
                    <Trans>MemberProfile</Trans>
                  </Link>
                </li>
              )}
              {permissions.includes("UpdateDesignation") && (
                <li className="nav-item">
                  <Link
                    className={
                      isPathActive("/member/update/designation")
                        ? "nav-link active"
                        : "nav-link"
                    }
                    to="member/update/designation"
                  >
                    <Trans>UpdateDesignation</Trans>
                  </Link>
                </li>
              )}
            </ul>
          </Collapse>
        </li>

        {/* SHG Menu */}
        <li className={isPathActive("/SHG") ? "nav-item active" : "nav-item"}>
          {permissions.includes("SHGMenu") && (
            <div
              className={
                menuState.shgMenuOpen ? "nav-link menu-expanded" : "nav-link"
              }
              onClick={() => toggleMenuState("shgMenuOpen")}
              data-toggle="collapse"
            >
              <span className="menu-title">
                <Trans>SHG</Trans>
              </span>
              <i className="menu-arrow"></i>
              <i className="mdi mdi-group menu-icon"></i>
            </div>
          )}
          <Collapse in={menuState.shgMenuOpen}>
            <ul className="nav flex-column sub-menu">
              {permissions.includes("AddSHG") && (
                <li className="nav-item">
                  <Link
                    className={
                      isPathActive("/SHG/add") ? "nav-link active" : "nav-link"
                    }
                    to="SHG/add"
                  >
                    <Trans>Add SHG</Trans>
                  </Link>
                </li>
              )}
              {permissions.includes("SHGProfile") && (
                <li className="nav-item">
                  <Link
                    className={
                      isPathActive("/SHG/profile")
                        ? "nav-link active"
                        : "nav-link"
                    }
                    to="SHG/profile"
                  >
                    <Trans>SHG Profile</Trans>
                  </Link>
                </li>
              )}
              {permissions.includes("ManageSHG") && (
                <li className="nav-item">
                  <Link
                    className={
                      isPathActive("/SHG/manage")
                        ? "nav-link active"
                        : "nav-link"
                    }
                    to="SHG/manage"
                  >
                    <Trans>Manage SHG</Trans>
                  </Link>
                </li>
              )}
              {permissions.includes("JoinSHG") && (
                <li className="nav-item">
                  <Link
                    className={
                      isPathActive("/SHG/join") ? "nav-link active" : "nav-link"
                    }
                    to="SHG/join"
                  >
                    <Trans>Join SHG</Trans>
                  </Link>
                </li>
              )}
              {permissions.includes("ManageSHGMember") && (
                <li className="nav-item">
                  <Link
                    className={
                      isPathActive("/SHG/member/manage")
                        ? "nav-link active"
                        : "nav-link"
                    }
                    to="SHG/member/manage"
                  >
                    <Trans> Manage SHG Member</Trans>
                  </Link>
                </li>
              )}
            </ul>
          </Collapse>
        </li>

        {/* Loan Menu */}
        <li className={isPathActive("/loan") ? "nav-item active" : "nav-item"}>
          {permissions.includes("LoanMenu") && (
            <div
              className={
                menuState.loanMenuOpen ? "nav-link menu-expanded" : "nav-link"
              }
              onClick={() => toggleMenuState("loanMenuOpen")}
              data-toggle="collapse"
            >
              <span className="menu-title">
                <Trans>Loan</Trans>
              </span>
              <i className="menu-arrow"></i>
              <i className="mdi mdi-cash menu-icon"></i>
            </div>
          )}
          <Collapse in={menuState.loanMenuOpen}>
            <ul className="nav flex-column sub-menu">
              {permissions.includes("NewLoan") && (
                <li className="nav-item">
                  <Link
                    className={
                      isPathActive("/loan/new") ? "nav-link active" : "nav-link"
                    }
                    to="loan/new"
                  >
                    <Trans>New Loan</Trans>
                  </Link>
                </li>
              )}

              {/* {permissions.includes("NewLoan") && (
                <li className="nav-item">
                  <Link
                    className={
                      isPathActive("/loan/new/applications")
                        ? "nav-link active"
                        : "nav-link"
                    }
                    to="loan/new/applications"
                  >
                    <Trans>New Loan Applications</Trans>
                  </Link>
                </li>
              )} */}
              {permissions.includes("DailyLoanReport") && (
                <li className="nav-item">
                  <Link
                    className={
                      isPathActive("/loan/report/daily")
                        ? "nav-link active"
                        : "nav-link"
                    }
                    to="loan/report/daily"
                  >
                    <Trans>Daily Loan Report</Trans>
                  </Link>
                </li>
              )}
              {permissions.includes("ManageLoan") && (
                <li className="nav-item">
                  <Link
                    className={
                      isPathActive("/loan/manage")
                        ? "nav-link active"
                        : "nav-link"
                    }
                    to="loan/manage"
                  >
                    <Trans>Manage Loan</Trans>
                  </Link>
                </li>
              )}
              {permissions.includes("LoanRepayment") && (
                <li className="nav-item">
                  <Link
                    className={
                      isPathActive("/loan/repayment")
                        ? "nav-link active"
                        : "nav-link"
                    }
                    to="loan/repayment"
                  >
                    <Trans>Loan Repayment</Trans>
                  </Link>
                </li>
              )}
              {permissions.includes("ManageLoanRepayment") && (
                <li className="nav-item">
                  <Link
                    className={
                      isPathActive("/loan/epayment/manage")
                        ? "nav-link active"
                        : "nav-link"
                    }
                    to="loan/epayment/manage"
                  >
                    <Trans>Manage Loan Repayment</Trans>
                  </Link>
                </li>
              )}
              <li className="nav-item">
                <Link
                  className={
                    isPathActive("/loan/view/bill")
                      ? "nav-link active"
                      : "nav-link"
                  }
                  to="loan/view/bill"
                >
                  <Trans>View Bill</Trans>
                </Link>
              </li>
            </ul>
          </Collapse>
        </li>

        {/* Interest & Installment Menu */}
        <li
          className={
            isPathActive("/intrest") ? "nav-item active" : "nav-item"
          }
        >
          {permissions.includes("IntrestInstallmentMenu") && (
            <div
              className="nav-link"
              onClick={() => toggleMenuState("intrestMenuOpen")}
              data-toggle="collapse"
            >
              <span className="menu-title">
                <Trans>Interest & Installment</Trans>
              </span>
              <i className="menu-arrow"></i>
              <i className="mdi mdi-cash-multiple menu-icon"></i>
            </div>
          )}

          <Collapse in={menuState.intrestMenuOpen}>
            <ul className="nav flex-column sub-menu">
              {/* Interest Submenu */}
              {permissions.includes("AddIntrest") && (
                <li className="nav-item">
                  <Link
                    className={
                      isPathActive("/intrest") ? "nav-link active" : "nav-link"
                    }
                    to="intrest"
                  >
                    <Trans>Interest</Trans>
                  </Link>
                </li>
              )}

              {/* Installment Submenu */}
              {permissions.includes("AddInstallment") && (
                <li className="nav-item">
                  <Link
                    className={
                      isPathActive("/intrest/installment")
                        ? "nav-link active"
                        : "nav-link"
                    }
                    to="intrest/installment"
                  >
                    <Trans>Installment</Trans>
                  </Link>
                </li>
              )}
            </ul>
          </Collapse>
        </li>

        {/* Loan Type Menu */}
        {permissions.includes("LoanType") && (
          <li
            className={
              isPathActive("/type/loan") ? "nav-item active" : "nav-item"
            }
          >
            <Link className="nav-link" to="type/loan">
              <span className="menu-title">
                <Trans>Loan Type</Trans>
              </span>
              <i className="mdi mdi-map menu-icon"></i>
            </Link>
          </li>
        )}

        {/* Voucher Menu */}

        <li
          className={isPathActive("/vouchers") ? "nav-item active" : "nav-item"}
        >
          {permissions.includes("VoucherMenu") && (
            <div
              className={
                menuState.vouchersMenuOpen
                  ? "nav-link menu-expanded"
                  : "nav-link"
              }
              onClick={() => toggleMenuState("vouchersMenuOpen")}
              data-toggle="collapse"
            >
              <span className="menu-title">
                <Trans>Vouchers</Trans>
              </span>
              <i className="menu-arrow"></i>
              <i className="mdi mdi-file-document menu-icon"></i>
            </div>
          )}

          <Collapse in={menuState.vouchersMenuOpen}>
            <ul className="nav flex-column sub-menu">
              {permissions.includes("AddAccount") && (
                <li className="nav-item">
                  <Link
                    className={
                      isPathActive("/vouchers/accounts")
                        ? "nav-link active"
                        : "nav-link"
                    }
                    to="/vouchers/accounts"
                  >
                    <Trans>Accounts</Trans>
                  </Link>
                </li>
              )}
              {permissions.includes("AddVoucherType") && (
                <li className="nav-item">
                  <Link
                    className={
                      isPathActive("/vouchers/type")
                        ? "nav-link active"
                        : "nav-link"
                    }
                    to="vouchers/type"
                  >
                    <Trans>Voucher Type</Trans>
                  </Link>
                </li>
              )}
              {permissions.includes("ManageVoucherTypeMappings") && (
                <li className="nav-item">
                  <Link
                    className={
                      isPathActive("/vouchers/type/mappings")
                        ? "nav-link active"
                        : "nav-link"
                    }
                    to="vouchers/type/mappings"
                  >
                    <Trans>Voucher Type Mappings</Trans>
                  </Link>
                </li>
              )}
            </ul>
          </Collapse>
        </li>

        {/* Transactions Menu */}
        <li
          className={
            isPathActive("/transaction") ? "nav-item active" : "nav-item"
          }
        >
          {permissions.includes("TransactionMenu") && (
            <div
              className={
                menuState.transactionsMenuOpen
                  ? "nav-link menu-expanded"
                  : "nav-link"
              }
              onClick={() => toggleMenuState("transactionsMenuOpen")}
              data-toggle="collapse"
            >
              <span className="menu-title">
                <Trans>Transactions</Trans>
              </span>
              <i className="menu-arrow"></i>
              <i className="mdi mdi-swap-horizontal menu-icon"></i>
            </div>
          )}
          <Collapse in={menuState.transactionsMenuOpen}>
            <ul className="nav flex-column sub-menu">
              {permissions.includes("TransactionProfile") && (
                <li className="nav-item">
                  <Link
                    className={
                      isPathActive("/transaction/profile")
                        ? "nav-link active"
                        : "nav-link"
                    }
                    to="transaction/profile"
                  >
                    <Trans>Transaction Profile</Trans>
                  </Link>
                </li>
              )}
              {permissions.includes("AddReceipt") && (
                <li className="nav-item">
                  <Link
                    className={
                      isPathActive("/transaction/add/receipt")
                        ? "nav-link active"
                        : "nav-link"
                    }
                    to="transaction/add/receipt"
                  >
                    <Trans>Receipt</Trans>
                  </Link>
                </li>
              )}
              {permissions.includes("AddPayments") && (
                <li className="nav-item">
                  <Link
                    className={
                      isPathActive("/transaction/add/payments")
                        ? "nav-link active"
                        : "nav-link"
                    }
                    to="transaction/add/payments"
                  >
                    <Trans>Payments</Trans>
                  </Link>
                </li>
              )}
              {permissions.includes("ViewReceipt") && (
                <li className="nav-item">
                  <Link
                    className={
                      isPathActive("/transaction/view/receipt")
                        ? "nav-link active"
                        : "nav-link"
                    }
                    to="transaction/view/receipt"
                  >
                    <Trans>View Receipt</Trans>
                  </Link>
                </li>
              )}
              {permissions.includes("ViewPayments") && (
                <li className="nav-item">
                  <Link
                    className={
                      isPathActive("/transaction/view/payment")
                        ? "nav-link active"
                        : "nav-link"
                    }
                    to="transaction/view/payment"
                  >
                    <Trans>View Payments</Trans>
                  </Link>
                </li>
              )}
              {permissions.includes("ManageReceipt") && (
                <li className="nav-item">
                  <Link
                    className={
                      isPathActive("/transaction/manage/receipt")
                        ? "nav-link active"
                        : "nav-link"
                    }
                    to="transaction/manage/receipt"
                  >
                    <Trans>Manage Receipt</Trans>
                  </Link>
                </li>
              )}
              {permissions.includes("ManagePayments") && (
                <li className="nav-item">
                  <Link
                    className={
                      isPathActive("/transaction/manage/payments")
                        ? "nav-link active"
                        : "nav-link"
                    }
                    to="transaction/manage/payments"
                  >
                    <Trans>Manage Payments</Trans>
                  </Link>
                </li>
              )}
            </ul>
          </Collapse>
        </li>

        {/* Cash Book Menu */}
        {permissions.includes("Cashbook") && (
          <li
            className={
              isPathActive("/cashbook") ? "nav-item active" : "nav-item"
            }
          >
            <Link className="nav-link" to="cashbook">
              <span className="menu-title">
                <Trans>Cash Book</Trans>
              </span>
              <i className="mdi mdi-cash-register menu-icon"></i>
            </Link>
          </li>
        )}

        {/* User Menu */}
        <li className={isPathActive("/user") ? "nav-item active" : "nav-item"}>
          {permissions.includes("UserMenu") && (
            <div
              className={
                menuState.userMenuOpen ? "nav-link menu-expanded" : "nav-link"
              }
              onClick={() => toggleMenuState("userMenuOpen")}
              data-toggle="collapse"
            >
              <span className="menu-title">
                <Trans>User</Trans>
              </span>
              <i className="menu-arrow"></i>
              <i className="mdi mdi-account-key menu-icon"></i>
            </div>
          )}
          <Collapse in={menuState.userMenuOpen}>
            <ul className="nav flex-column sub-menu">
              {permissions.includes("AddUser") && (
                <li className="nav-item">
                  <Link
                    className={
                      isPathActive("/user/manage")
                        ? "nav-link active"
                        : "nav-link"
                    }
                    to="user/manage"
                  >
                    <Trans>Users</Trans>
                  </Link>
                </li>
              )}
              {permissions.includes("AddPermissions") && (
                <li className="nav-item">
                  <Link
                    className={
                      isPathActive("/user/permission")
                        ? "nav-link active"
                        : "nav-link"
                    }
                    to="user/permission"
                  >
                    <Trans>Permissions</Trans>
                  </Link>
                </li>
              )}
              {permissions.includes("AddRole") && (
                <li className="nav-item">
                  <Link
                    className={
                      isPathActive("/user/role")
                        ? "nav-link active"
                        : "nav-link"
                    }
                    to="user/role"
                  >
                    <Trans>User Role</Trans>
                  </Link>
                </li>
              )}
            </ul>
          </Collapse>
        </li>

        {/* Document Menu */}
        <li
          className={isPathActive("/document") ? "nav-item active" : "nav-item"}
        >
          {permissions.includes("DocsMenu") && (
            <div
              className={
                menuState.documentMenuOpen
                  ? "nav-link menu-expanded"
                  : "nav-link"
              }
              onClick={() => toggleMenuState("documentMenuOpen")}
              data-toggle="collapse"
            >
              <span className="menu-title">
                <Trans>Document</Trans>
              </span>
              <i className="menu-arrow"></i>
              <i class="mdi mdi-file-multiple menu-icon"></i>
            </div>
          )}
          <Collapse in={menuState.documentMenuOpen}>
            <ul className="nav flex-column sub-menu">
              {permissions.includes("AddDocs") && (
                <li className="nav-item">
                  <Link
                    className={
                      isPathActive("/document/add")
                        ? "nav-link active"
                        : "nav-link"
                    }
                    to="document/add"
                  >
                    <Trans>Add Document</Trans>
                  </Link>
                </li>
              )}
              {permissions.includes("ViewDocs") && (
                <li className="nav-item">
                  <Link
                    className={
                      isPathActive("/document/view")
                        ? "nav-link active"
                        : "nav-link"
                    }
                    to="document/view"
                  >
                    <Trans>View Document</Trans>
                  </Link>
                </li>
              )}
              {permissions.includes("AddGovtDocs") && (
                <li className="nav-item">
                  <Link
                    className={
                      isPathActive("/document/govt/add")
                        ? "nav-link active"
                        : "nav-link"
                    }
                    to="document/govt/add"
                  >
                    <Trans>Add Govt Document</Trans>
                  </Link>
                </li>
              )}
              {permissions.includes("ViewGovtDocs") && (
                <li className="nav-item">
                  <Link
                    className={
                      isPathActive("/document/govt/view")
                        ? "nav-link active"
                        : "nav-link"
                    }
                    to="document/govt/view"
                  >
                    <Trans>View Govt Documents</Trans>
                  </Link>
                </li>
              )}
            </ul>
          </Collapse>
        </li>

        {/* JFMC Maintenance Fee Menu — hidden when payment is disabled */}
        <li
          className={isPathActive("/jfmc-fee") ? "nav-item active" : "nav-item"}
        >
          <div
            className={
              menuState.jfmcMaintenanceFeeMenuOpen
                ? "nav-link menu-expanded"
                : "nav-link"
            }
            onClick={() => toggleMenuState("jfmcMaintenanceFeeMenuOpen")}
          >
            <span className="menu-title">
              <Trans>JFMC Maintanance Fee</Trans>
            </span>
            <i className="menu-arrow"></i>
            <i className="mdi mdi-cash-multiple menu-icon"></i>
          </div>

          <Collapse in={menuState.jfmcMaintenanceFeeMenuOpen}>
            <ul className="nav flex-column sub-menu">

              {/* ✅ ALWAYS VISIBLE */}
              <li className="nav-item">
                <Link
                  className={
                    isPathActive("/jfmc-fee/add")
                      ? "nav-link active"
                      : "nav-link"
                  }
                  to="jfmc-fee/add"
                >
                  <Trans>Add Maintanance Fee</Trans>
                </Link>
              </li>

              {/* 🔥 CONDITIONAL OPTIONS */}
              {process.env.REACT_APP_PAYMENT_ENABLED === "true" && (
                <>
                  {permissions.includes("VerifyManualPayments") && (
                    <li className="nav-item">
                      <Link
                        className={
                          isPathActive("/jfmc-fee/bank-upload")
                            ? "nav-link active"
                            : "nav-link"
                        }
                        to="jfmc-fee/bank-upload"
                      >
                        <Trans>Bank Statement Upload</Trans>
                      </Link>
                    </li>
                  )}

                  {permissions.includes("VerifyManualPayments") && (
                    <li className="nav-item">
                      <Link
                        className={
                          isPathActive("/verify-manual-payments")
                            ? "nav-link active"
                            : "nav-link"
                        }
                        to="verify-manual-payments"
                      >
                        <Trans>Verify Manual Payments</Trans>
                      </Link>
                    </li>
                  )}
                </>
              )}

            </ul>
          </Collapse>
        </li>
      </ul>
    </nav>
  );
};

export default Sidebar;
